module.exports = __webpack_public_path__ + "4dbfbac5d315804bb039b8035336f383.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/preOrder.svg
// module id = 210
// module chunks = 0